export default function PHP_srand() {
  return (
    <div>
      <h1>PHP_srand</h1>
    </div>
  );
}
